'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../../../../../popmotion/dist/es/utils/clamp.js');
require('../../../../../../popmotion/dist/es/animations/generators/spring.js');
require('../../../../../../popmotion/dist/es/utils/progress.js');
const mix = require('../../../../../../popmotion/dist/es/utils/mix.js');
require('../../../../../../popmotion/dist/es/utils/mix-color.js');
require('../../../../../../popmotion/dist/es/utils/pipe.js');
require('../../../../../../popmotion/dist/es/utils/mix-complex.js');
require('../../../../../../popmotion/dist/es/utils/interpolate.js');
require('../../../../../../popmotion/dist/es/easing/utils.js');
require('../../../../../../popmotion/dist/es/easing/index.js');
require('../../../../../../popmotion/dist/es/animations/generators/keyframes.js');
require('../../../../../../popmotion/dist/es/animations/generators/decay.js');
require('../../../../../../popmotion/dist/es/animations/index.js');
require('../../../../../../popmotion/dist/es/utils/velocity-per-second.js');
require('../../../../../../popmotion/dist/es/animations/inertia.js');
require('../../../../../../popmotion/dist/es/utils/is-point.js');
require('../../../../../../popmotion/dist/es/utils/is-point-3d.js');
require('../../../../../../popmotion/dist/es/utils/distance.js');
require('../../../../../../popmotion/dist/es/easing/cubic-bezier.js');

function tweenAxis(target, prev, next, p) {
  target.min = mix.mix(prev.min, next.min, p);
  target.max = mix.mix(prev.max, next.max, p);
}

exports.tweenAxis = tweenAxis;
